module.exports = __webpack_public_path__ + "static/media/appear.db4b3eab.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/appear.png
// module id = 79
// module chunks = 0